import { Icon } from '@iconify/react'

import styles from '../../ProjectStoryMapBoard.module.css'

const BoardJourneyToolbar = ({ onAddJourney }) => (
    <div className={styles.boardJourneyToolbar}>
        <button
            type="button"
            className={styles.addJourneyBtn}
            onClick={onAddJourney}
        >
            <Icon icon="mdi:plus" width={14} />
            ADD JOURNEY
        </button>
    </div>
)

export default BoardJourneyToolbar
